export default __webpack_public_path__ + "static/media/linkdin.38f43880.svg";